module.exports = __webpack_public_path__ + "static/media/develop_icon.e31afb1c.svg";